import {DataAboutContainer} from './styles'

export function DataAbout(){
    return (
        <DataAboutContainer>
         <div>
            <i className="uil uil-award-alt"></i>
            <h3>Experiência</h3>
            <p>+ 5 anos</p>
         </div>
         <div>
            <i className="uil uil-briefcase-alt"></i>
            <h3>Entregas</h3>
            <p>+ 30 Projetos</p>
         </div>
         <div>
            <i className="uil uil-favorite"></i>
            <h3>Satisfação</h3>
            <p> + 5 estrelas</p>
         </div>
        </DataAboutContainer>
    )
}